import { GenIcon } from '../helpers/IconBase.es.js';

const LocationFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_1338_1361)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M7.9997 0.0283203C6.23566 0.030261 4.54442 0.731837 3.29699 1.97914C2.04957 3.22644 1.34782 4.91762 1.3457 6.68165C1.3457 8.39499 2.67237 11.0763 5.28904 14.651C5.60054 15.0777 6.00841 15.4249 6.47944 15.6643C6.95047 15.9036 7.47135 16.0283 7.9997 16.0283C8.52805 16.0283 9.04894 15.9036 9.51997 15.6643C9.991 15.4249 10.3989 15.0777 10.7104 14.651C13.327 11.0763 14.6537 8.39499 14.6537 6.68165C14.6516 4.91762 13.9498 3.22644 12.7024 1.97914C11.455 0.731837 9.76374 0.030261 7.9997 0.0283203ZM7.9997 9.33365C7.47229 9.33365 6.95671 9.17726 6.51818 8.88424C6.07965 8.59122 5.73786 8.17475 5.53602 7.68748C5.33419 7.20021 5.28138 6.66403 5.38428 6.14675C5.48717 5.62946 5.74115 5.15431 6.11409 4.78137C6.48703 4.40843 6.96218 4.15445 7.47946 4.05156C7.99675 3.94867 8.53292 4.00148 9.02019 4.20331C9.50746 4.40514 9.92394 4.74694 10.217 5.18547C10.51 5.624 10.6664 6.13957 10.6664 6.66699C10.6664 7.37423 10.3854 8.05251 9.88532 8.55261C9.38522 9.0527 8.70695 9.33365 7.9997 9.33365Z",
              fill: "#0200BC"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_1338_1361" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { LocationFilled };
